import React from 'react';
import { Row, Col } from 'react-bootstrap';
import className from 'classnames';
import Section from 'components/common/Section';
import CardService from './CardService';
import SectionHeader from './SectionHeader';
import { useTranslation } from 'react-i18next';

const serviceKeys = [
  { media: { icon: 'robot', color: 'primary', className: 'fs-4' }, titleKey: 'TOOL_AUTOREPLIES_TITLE', descKey: 'TOOL_AUTOREPLIES_DESC' },
  { media: { icon: 'comments', color: 'info', className: 'fs-4' }, titleKey: 'TOOL_CHATBOT_TITLE', descKey: 'TOOL_CHATBOT_DESC' },
  { media: { icon: 'users', color: 'success', className: 'fs-4' }, titleKey: 'TOOL_OPERATORS_TITLE', descKey: 'TOOL_OPERATORS_DESC' },
  { media: { icon: 'exclamation-triangle', color: 'warning', className: 'fs-4' }, titleKey: 'TOOL_STOCK_TITLE', descKey: 'TOOL_STOCK_DESC' },
  { media: { icon: 'print', color: 'danger', className: 'fs-4' }, titleKey: 'TOOL_LABELS_TITLE', descKey: 'TOOL_LABELS_DESC' },
  { media: { icon: 'magic', color: 'secondary', className: 'fs-4' }, titleKey: 'TOOL_LISTINGS_TITLE', descKey: 'TOOL_LISTINGS_DESC' }
];

const Services = () => {
  const { t } = useTranslation();

  return (
    <Section bg="light" className="text-center" id="features">
      <SectionHeader
        title={t('LANDING.TOOLS_TITLE')}
        subtitle={t('LANDING.TOOLS_SUBTITLE')}
      />
      <Row className="mt-6">
        {serviceKeys.map((service, index) => (
          <Col
            lg={4}
            className={className({ 'mt-6 mt-lg-0': index > 2 }, 'mb-4')}
            key={index}
          >
            <CardService
              media={service.media}
              title={t(`LANDING.${service.titleKey}`)}
              description={t(`LANDING.${service.descKey}`)}
            />
          </Col>
        ))}
      </Row>
    </Section>
  );
};

export default Services;
